import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import CustomerLogin from "./pages/CustomerLogin";
import TestPage from "./pages/TestPage";
import EvaluatePage from "./pages/EvaluatePage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { Toaster } from "./components/ui/sonner";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="w-6 h-6 animate-spin text-brand" />
      </div>
    );
  }
  return user ? children : <Navigate to="/admin/login" replace />;
};

function App() {
  useEffect(() => {
    const title = "PartVision AI | AI-Powered Visual Spare Parts Finder";
    document.title = title;
    // Re-assert shortly after mount in case an external script overrides it on load.
    const t = setTimeout(() => { document.title = title; }, 1200);
    return () => clearTimeout(t);
  }, []);
  return (
    <AuthProvider>
      <CustomerAuthProvider>
        <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<CustomerLogin />} />
          <Route path="/test" element={<TestPage />} />
          <Route path="/evaluate" element={<EvaluatePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="bottom-right" />
      </BrowserRouter>
      </CustomerAuthProvider>
    </AuthProvider>
  );
}

export default App;
